export default {
    BULKPAYMENTLIST: ({ savings_id }) => `/cdf-payments/stage/${savings_id}/`,
    CHECKERSLIST: ({ savings_id }) => `bulk-payments/operator-list/${savings_id}/`,
    // STAGEBULKPAYMENT: `bulk-payments/stage/`,
    STAGEBULKPAYMENT:  `/cdf-payments/stage/`,
    SINGLEBULKPAYMENT: ({ id }) => `/cdf-payments/${id}/process/upload-payment-wages/`,
    DELETE_BULK_RECORD:`bulk-payments/delete/`,
}


